module.exports = __webpack_public_path__ + "img/sct_kefu.ddcd9409.png";